const storeTypes = {
  PET_GUARDIANS: "PET_GUARDIANS",
  ALT_PET_GUARDIAN: "ALT_PET_GUARDIAN",
  CHILD_GUARDIAN: "CHILD_GUARDIAN",
  ALT_CHILD_GUARDIAN: "ALT_CHILD_GUARDIAN",
};
export default storeTypes;
